export default __webpack_public_path__ + "static/media/sellout-logo-long-white.502b35d8.svg";